import React from 'react';
import styles from './number-of-records.module.scss';
import { useTranslation } from '@hooks/index';

interface NumberOfRecordsProps {
    number: number;
}

const NumberOfRecords = ({ number }: NumberOfRecordsProps) => {
    const { t } = useTranslation();
    return (
        <div data-testid="number-of-records" className={styles.text}>
            ({`${number} ${t('Records')}`})
        </div>
    );
};

export default NumberOfRecords;
